import TabsMenu from './TabsMenu';

export default TabsMenu;
